import HvalenaGradient from "../assets/pictures/avatars/hvalena_gradient_preview.png";
import HvalenaWhite from "../assets/pictures/avatars/hvalena_white_preview.png";
import HvalenaOrange from "../assets/pictures/avatars/hvalena_orange_preview.png";

import female01Gradient from "../assets/pictures/avatars/female01_gradient_preview.jpg";
import female02Gradient from "../assets/pictures/avatars/female02_gradient_preview.jpg";
import female03Gradient from "../assets/pictures/avatars/female03_gradient_preview.jpg";
import female04Gradient from "../assets/pictures/avatars/female04_gradient_preview.jpg";
import redwomanGradient from "../assets/pictures/avatars/redwoman_gradient_preview.jpg";
import male01Gradient from "../assets/pictures/avatars/male01_gradient_preview.jpg";
import male02Gradient from "../assets/pictures/avatars/male02_gradient_preview.jpg";
import male03Gradient from "../assets/pictures/avatars/male03_gradient_preview.jpg";
import male04Gradient from "../assets/pictures/avatars/male04_gradient_preview.jpg";
import kirillGradient from "../assets/pictures/avatars/kirill_gradient_preview.jpg";

import female01White from "../assets/pictures/avatars/female01_white_preview.jpg";
import female02White from "../assets/pictures/avatars/female02_white_preview.jpg";
import female03White from "../assets/pictures/avatars/female03_white_preview.jpg";
import female04White from "../assets/pictures/avatars/female04_white_preview.jpg";
import redwomanWhite from "../assets/pictures/avatars/redwoman_white_preview.jpg";
import male01White from "../assets/pictures/avatars/male01_white_preview.jpg";
import male02White from "../assets/pictures/avatars/male02_white_preview.jpg";
import male03White from "../assets/pictures/avatars/male03_white_preview.jpg";
import male04White from "../assets/pictures/avatars/male04_white_preview.jpg";
import kirillWhite from "../assets/pictures/avatars/kirill_white_preview.jpg";

import female01Orange from "../assets/pictures/avatars/female01_orange_preview.jpg";
import female02Orange from "../assets/pictures/avatars/female02_orange_preview.jpg";
import female03Orange from "../assets/pictures/avatars/female03_orange_preview.jpg";
import female04Orange from "../assets/pictures/avatars/female04_orange_preview.jpg";
import redwomanOrange from "../assets/pictures/avatars/redwoman_orange_preview.jpg";
import male01Orange from "../assets/pictures/avatars/male01_orange_preview.jpg";
import male02Orange from "../assets/pictures/avatars/male02_orange_preview.jpg";
import male03Orange from "../assets/pictures/avatars/male03_orange_preview.jpg";
import male04Orange from "../assets/pictures/avatars/male04_orange_preview.jpg";
import kirillOrange from "../assets/pictures/avatars/kirill_orange_preview.jpg";

export const avatarImg: Record<string, string> = {
	alena_gradient: HvalenaGradient,
	alena_white: HvalenaWhite,
	alena_orange: HvalenaOrange,
	tanya_white: female01White,
	olga_white: female02White,
	arina_white: female03White,
	sonia_white: female04White,
	lily_white: redwomanWhite,
	ivan_white: male01White,
	nikita_white: male02White,
	kirill_white: kirillWhite,
	dmitriy_white: male03White,
	oleg_white: male04White,
	tanya_gradient: female01Gradient,
	olga_gradient: female02Gradient,
	arina_gradient: female03Gradient,
	sonia_gradient: female04Gradient,
	lily_gradient: redwomanGradient,
	ivan_gradient: male01Gradient,
	nikita_gradient: male02Gradient,
	dmitriy_gradient: male03Gradient,
	kirill_gradient: kirillGradient,
	oleg_gradient: male04Gradient,
	tanya_orange: female01Orange,
	olga_orange: female02Orange,
	arina_orange: female03Orange,
	sonia_orange: female04Orange,
	lily_orange: redwomanOrange,
	ivan_orange: male01Orange,
	nikita_orange: male02Orange,
	dmitriy_orange: male03Orange,
	oleg_orange: male04Orange,
	kirill_orange: kirillOrange
};